import { render, staticRenderFns } from "./LandingPageCmh.vue?vue&type=template&id=6e94004b&scoped=true"
import script from "./LandingPageCmh.vue?vue&type=script&lang=ts"
export * from "./LandingPageCmh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94004b",
  null
  
)

export default component.exports